"use client";
import { usePathname } from "next/navigation";
import { useEffect, useState } from "react";
import { isPublicRoute } from "@/lib/route-config";

/**
 * NavigationEvents component tracks and responds to navigation changes in the app.
 * It conditionally renders children based on route type (public vs protected).
 * For public routes (login, register, etc.), it renders children without layout components.
 * For protected routes, it renders the full layout with sidebar and header.
 */

interface NavigationEventsProps {
  children: React.ReactNode;
  protectedLayout?: React.ReactNode;
}

export function NavigationEvents({
  children,
  protectedLayout,
}: NavigationEventsProps) {
  const pathname = usePathname();
  const [mounted, setMounted] = useState(false);

  useEffect(() => setMounted(true), []);

  if (!mounted) return null;

  // For public routes (login, register, etc.), render children without layout
  if (isPublicRoute(pathname)) {
    return <>{children}</>;
  }

  // For protected routes, render with the protected layout or just children
  return <>{protectedLayout || children}</>;
}
